import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

// initial state
const state = () => ({
  selectionData: null,
});

// actions
const actions = {
  async fetchEventSelectionById({ commit }, eventId, fetcher = dataFetch) {
    try {
      const eventIncludeString = 'selections';
      const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${eventId}?include=${eventIncludeString}`;
      const res = await fetcher(eventEndpoint);

      const eventData = res.data.event;
      const { selections } = eventData;

      if (Array.isArray(selections) && selections.length > 0) {
        const statsByEvent = await getStatsByEvent(eventId);
        const eventsIncludeString = 'results,venue,prize_money,entry_conditions,selections';
        const recordsData = await getRecordsData(selections, eventsIncludeString);

        // set selections with stats and records
        const result = selections.map((item, index) => {
          const stats = statsByEvent.stats.filter(stat => stat.selection_id === item.id);
          const { events } = recordsData[index].data;

          return {
            ...item,
            stats: stats[0],
            records: events,
          };
        });

        commit('SET_SELECTION_DATA', result);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async fetchEventSelectionBySlug({ commit }, { slug, eventNumber }, fetcher = dataFetch) {
    try {
      const meetingEndpoint = `${API_END_POINTS.HARNESS.MEETING}${slug}?include=events`;
      const res = await fetcher(meetingEndpoint);
      // set meeting
      const meetingData = res.data.meeting;
      const eventDataArray = meetingData.events.filter(event => {
        return event.event_number == eventNumber;
      });

      if (eventDataArray.length > 0) {
        // set event data
        const event = eventDataArray[0];
        const includeString = 'selections';
        const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${event.id}?include=${includeString}`;
        const res = await fetcher(eventEndpoint);

        const eventData = res.data.event;
        const { selections } = eventData;

        if (Array.isArray(selections) && selections.length > 0) {
          const statsByEvent = await getStatsByEvent(event.id);
          const eventsIncludeString = 'results,venue,prize_money,entry_conditions,selections';
          const recordsData = await getRecordsData(selections, eventsIncludeString);

          // set selections with stats and records
          const result = selections.map((item, index) => {
            const { events } = recordsData[index].data;
            const stats = statsByEvent.stats.filter(stat => stat.selection_id === item.id);
            return {
              ...item,
              stats: stats[0],
              records: events,
            };
          });

          commit('SET_SELECTION_DATA', result);
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
};

async function getRecordsData(selections, includeString, fetcher = dataFetch) {
  try {
    const recordsArray = selections.map(item => {
      const recordsUrl = `${API_END_POINTS.HARNESS.EVENTS}?include=${includeString}&competitorId=${item.competitor_id}`;
      return fetcher(recordsUrl);
    });
    return await Promise.all(recordsArray).then(values => values);
  } catch (error) {
    console.log(error);
  }
}

async function getStatsByEvent(eventId, fetcher = dataFetch) {
  try {
    const statsEndpoint = `${API_END_POINTS.HARNESS.STATS}?events=${eventId}`;
    const statsData = await fetcher(statsEndpoint);
    return statsData.data;
  } catch (error) {
    console.log(error);
  }
}

// mutations
const mutations = {
  SET_SELECTION_DATA: (state, selections) => {
    state.selectionData = selections;
  },
};

// getter
const getters = {
  getSelectionData: state => {
    return state.selectionData;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
